import React from 'react'

import { withRouter } from 'react-router-dom'

import { MultiSelect } from 'primereact/multiselect'
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Dropdown } from 'primereact/dropdown'
import { Calendar } from 'primereact/calendar'
import { Button } from 'primereact/button'
import { uniqueId } from "lodash"
import { InputTextarea } from 'primereact/inputtextarea'
import filesize from 'filesize'
import Upload from '../../componentes/Upload/Index'
import FileList from '../../componentes/FileList'
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { Dialog } from 'primereact/dialog'
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable' 
import { Column } from 'primereact/column'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import fileDownload from 'js-file-download'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { AuthContext } from '../../main/ProvedorAutenticacao'

import NavBar from '../../componentes/Navbar'

import RelatorioAtividadeService from '../../app/service/RelatorioAtividadeService'
import GrupoTrabalhoService from '../../app/service/GrupoTrabalhoService'
import StatusAtividadeService from '../../app/service/StatusAtividadeService'
import UsuarioService from '../../app/service/UsuarioService'
import AtividadeService from '../../app/service/AtividadeService'
import ArquivoAtividadeService from '../../app/service/ArquivoAtividadeService'
import UsuarioGrupoTrabalhoService from '../../app/service/UsuarioGrupoTrabalhoService'
import FaseTarefaService from '../../app/service/FaseTarefaService'

class RelatorioAtividades extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      empresa: '',
      detail: '',
      atividades: [],
      selectAtividades: null,
      //Filtros
      dataLimiteInicial: '',
      dataLimiteFinal: '',
      dataCadastroInicial: '',
      dataCadastroFinal: '',
      dataConcluidoInicial: '',
      dataConcluidoFinal: '',
      dataAlteracaoInicial: '',
      dataAlteracaoFinal: '',
      dataFatalInicial: '',
      dataFatalFinal: '',
      gruposTrabalho: [],
      grupoTrabalho: null,
      usuarios: [],
      tipo: null, 
      usuario: null,
      statusLista: [],
      status: null,
      tipoAtividade: null,
      ordenacao: null,
      classificacao: null,
      openSpinner: false,
      caminhoRelatorio: '',
      relatorioArquivo: null,
      relatorioGerado: [],
      atividades: [],
      codigoExcluirRelatorio: '',
      exibirTelaConsulta: 'none',
      //Alterações em Massa
      dataAlterarMassa: null,
      statusAlterarMassa: null,
      historicoAlterarMassa: '',
      alteraMassa: false,

      //Alterar Atividade
      modalAtividade: false,
      atividade: null,
      codigo: '',
      titulo: '',
      descricao: '',
      dtLimite: '',
      dtFatal: '',
      tipoAtividade: '',
      status: null,
      totalAtividades: '',
      hora: '',
      displayAtividade: false,
      displayProcesso: false,
      displayAtividade: false,
      displayProcesso: false,
      displayDescricao: false,
      tipoAtividadeAlterar: null,
      grupos: [],
      selectGrupo: null,
      subGrupos: [],
      selectSubGrupo: null,
      responsaveis: [],
      responsavel: null,
      interessados: [],
      interessado: null,
      pesquisaProcesso: '',
      sizePesquisa: 'col-sm-12',
      escondeBotalExcluirPesquisa: {display: 'none'},
      processos: [],
      processo: null,
      bloqueiaGrupo: false,
      optionStatus: null,
      responsaveisLista: [],
      quantidadeResponsaveis: '',
      interessadosLista: [],
      quantidadeInteressados: '',
      detail: '',
      processos: [],
      partes: '',
      favorito: '',
      titleFavorito: '',
      exibirFavorito: '',
      importante: '',
      titleImportante: '',
      exibirImportanteEmpresa: '',
      statusAtividade: [],
      selectStatusAtividade: null,
      statusAtividadeAlterar: null,

      campoPesquisaProcesso: '',
      processoPesquisadoVisivel: '',
      processoPesquisado: '',
      
      //Histórico
      historico: [],
      registroHistorico: null,
      displayHistorico: null,
      dsHistorico: '',
      displayHistoricoIncluir: false,
      visibleHistorico: false,
      //Arquivos Anexados
      exibirLinkAnexo: 'none',
      displayArquivosAnexados: false,
      upLoadFiles: [],
      nome: '',
      dsArquivo: '',
      arquivos: [],
      modalDescricaoArquivo: false,
      arquivo: null,
      arquivoCodigo: '',
      visibleExcluirArquivo: false,
      //Fases da Atividade
      fases: [],
      fase: null
    }

    this.relatorioAtividadeService = new RelatorioAtividadeService();
    this.grupoTrabalhoService = new GrupoTrabalhoService();
    this.statusAtividadeService = new StatusAtividadeService();
    this.usuarioService = new UsuarioService();
    this.atividadeService = new AtividadeService();
    this.arquivoAtividadeService = new ArquivoAtividadeService();
    this.usuarioGrupoTrabalhoService = new UsuarioGrupoTrabalhoService();
    this.faseTarefaService = new FaseTarefaService();

    this.acoes = this.acoes.bind(this);
    this.accepExcluirRelatorio = this.accepExcluirRelatorio.bind(this);
    this.renderFooterAlteraMassa = this.renderFooterAlteraMassa.bind(this);
    this.acoesAtividade = this.acoesAtividade.bind(this);
    this.renderFooterAtividade = this.renderFooterAtividade.bind(this);
    this.onChangeStatusAtividade = this.onChangeStatusAtividade.bind(this);
    this.acoesArquivos = this.acoesArquivos.bind(this);
    this.renderFooterDescricaoArquivo = this.renderFooterDescricaoArquivo.bind(this);
    this.acceptExcluirArquivo = this.acceptExcluirArquivo.bind(this);
    this.acoesHistorico = this.acoesHistorico.bind(this);
    this.acceptExcluirHistorico = this.acceptExcluirHistorico.bind(this);
    this.acoesHistoricoUsuario = this.acoesHistoricoUsuario.bind(this);

    this.tiposAtividade = [
      {codigo: 'A', nome: 'Compromissos/Audiências'},
      {codigo: 'T', nome: 'Tarefa'},
      {codigo: 'L', nome: 'Tarefa/Financeiro'}
    ];

    this.classificacoes = [
      {codigo: 1, nome: 'Data Limite'},
      {codigo: 2, nome: 'Data de Conclusão'},
      {codigo: 3, nome: 'Data de Cadastro'}
    ];

    this.ordenacoes = [
      {codigo: 1, nome: 'Ascendente'},
      {codigo: 2, nome: 'Decrescente'}
    ]

    this.tiposUsuario = [
      {codigo: 'R', nome: 'Responsável'},
      {codigo: 'I', nome: 'Interessado'}
    ]
  }

  listarFases = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.faseTarefaService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({fases: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar Fases da Atividade', life: 4000});
      })
  }

  onChangeStatusAtividade(e) {
    this.setState({statusAtividadeAlterar: e.value})
  }

  fecharModalAtividade(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  async abrirModalArquivosAnexos(name, position){
    this.setState({openSpinner: true});
    await this.listarArquivosAtividade()
    let state = {
      [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
    this.setState({openSpinner: false});
  }

  handleUpload = async files => {
    const upLoadFiles = files.map(file => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: filesize(file.size),
      progress: 0,
      uploaded: false, 
      error: false,
      url: file.url
    }))

    this.setState({
      upLoadFiles: this.state.upLoadFiles.concat(upLoadFiles)
    });

    await upLoadFiles.forEach(this.processar);
  }

  processar = async (upLoadFile) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const data = new FormData();
    data.append('file',upLoadFile.file);
    data.append('atividade',upLoadFile.file, this.state.atividade.codigo) //Envia código de atividade para salvar os arquivos
    data.append('usuario',upLoadFile.file, usuarioLogado.codigo) //Envia código de atividade para salvar os arquivos
    await this.arquivoAtividadeService.incluirArquivo(data)
      .then(response => {
        this.listarArquivosAtividade();
        this.handleDelete(upLoadFile.id);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  handleDelete  = async id => {
    this.setState({upLoadFiles: this.state.upLoadFiles.filter(file => file.id !== id)});
  } 

  acoesArquivos(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-comment" className="p-button-rounded p-button-text"
                tooltip="Adicionar descrição ao arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.consultarArquivoDescricao(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-cloud-download" className="p-button-rounded p-button-text"
                tooltip="Baixar Arquivo"
                onClick={() => this.downloadArquivos(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Arquivo"
                onClick={() => this.confirmaExclusaoArquivo(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  async consultarArquivoDescricao(arquivo){
    await this.arquivoAtividadeService.consultarArquivo(arquivo.codigo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({dsArquivo: response.data.dsArquivo});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });

      this.abrirModalDescricaoArquivo('modalDescricaoArquivo');
  }

  abrirModalDescricaoArquivo(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  renderFooterDescricaoArquivo(name) {
    return (
        <div>
            <Button label="Alterar" 
                    className="p-button-primary p-button-text"
                    onClick={this.adicionarDescricao}/> 
            &nbsp;
            <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModal(name)}/>
      </div>
    );
  }

  adicionarDescricao = () => {
    this.arquivoAtividadeService.adicionarDescricao({
      codigo: this.state.arquivo.codigo,
      dsArquivo: this.state.dsArquivo
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Arquivos', detail:'Descrição adicionada com sucesso', life: 4000});
      this.listarArquivosAtividade();
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
    });

    this.fecharModal('modalDescricaoArquivo');
  }
  async downloadArquivos (rowData){
    await this.consultarArquivo(rowData.codigo);
    await this.arquivoAtividadeService.download(rowData.codigo)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.state.arquivo.arquivo); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  }

  async consultarArquivo(arquivo){
    await this.arquivoAtividadeService.consultarArquivo(arquivo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({dsArquivo: response.data.dsArquivo});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });
  }

  confirmaExclusaoArquivo(arquivo) {
    this.setState({arquivoCodigo: arquivo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir este arquivo?',
        header: 'Exclusão de Arquivos',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirArquivo,
        reject: this.reject
    });
  }

  acceptExcluirArquivo() {
    this.excluirArquivo();
  }

  excluirArquivo = () => {
    this.arquivoAtividadeService.excluirArquivo(this.state.arquivoCodigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Arquivos', detail:'Arquivo excluído com sucesso', life: 4000});
        this.listarArquivosAtividade();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarHistorico = async () => {
    this.setState({openSpinner: true});
    await this.atividadeService.consultarHistorico(this.state.codigo)
      .then(response => {
        this.setState({historico: response.data});
        this.abrirModalHistorico('displayHistorico');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
      this.setState({openSpinner: false});
  }

  abrirModalHistorico(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  acoesHistorico(rowData) {
    if(rowData.tpHistorico != 'A') {
      return (
        <React.Fragment>
           <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                   tooltip="Excluir Histórico"
                   onClick={() => this.confirmaExclusaoHistorico(rowData)}
                   tooltipOptions={{position: 'top'}}
                   style={{width: '20px', height: '10px'}}/>
        </React.Fragment>
      )
    } 
  }

  confirmaExclusaoHistorico(historico) {
    this.setState({registroHistorico: historico});
    confirmDialog({
        message: 'Deseja realmente excluir o Histórico da Atividade?',
        header: 'Exclusão de Histórico de Atividades',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirHistorico,
        reject: this.reject
    });
  }

  acceptExcluirHistorico() {
    this.excluirHistorico();
  }

  excluirHistorico = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    this.setState({openSpinner: true});
    await this.atividadeService.excluirHistorico(this.state.registroHistorico.codigo, this.state.registroHistorico.usuario.codigo, usuarioLogado.codigo)
      .then(response => {
        this.listarHistorico();
        this.toast.show({severity:'success', summary: 'Atividades', detail:'Histórico excluído', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  listarHistorico = async () => {
    await this.atividadeService.consultarHistorico(this.state.codigo)
      .then(response => {
        this.setState({historico: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
    })
  }

  acoesHistoricoUsuario(rowData) {
    if(rowData.tpHistorico == 'A') {
      return (
        <React.Fragment>
          <i className="fa fa-solid fa-robot" title="Incluído de forma automática"/>
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          <i className="pi pi-user-plus" title="Incluído manualmente"/>
        </React.Fragment>
      )
    }
  }

  novoHistorico = () => {
    this.setState({dsHistorico: ''});
    this.abrirModalHistorico('displayHistoricoIncluir');
  }

  async incluirHistorico () {
    const usuarioLogado = this.context.usuarioAutenticado
    if(this.state.dsHistorico == '') {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o histórico da Atividade', life: 4000});
      return false;
    }

    let tipoHistorico = 'M';
    if(usuarioLogado.empresa.codigo == 138) {
      let data = 'N';
        if(this.state.mudancaDataHistorico != null & this.state.mudancaDataHistorico.length > 0) {
          for(let i = 0; i < this.state.mudancaDataHistorico.length; i++) {
            if(this.state.mudancaDataHistorico[i] == 'mudancaData') {
              data = 'S'
            }
          }
        }

        if(data == 'S') {
          tipoHistorico = 'D';
        } else {
          tipoHistorico = 'M';
        }
    } else {
      tipoHistorico = 'M';
    }

    this.setState({openSpinner: true});
    await this.atividadeService.incluirHistorico({
      atividade: this.state.atividade,
      dsHistorico: this.state.dsHistorico,
      usuario: usuarioLogado,
      tpHistorico: tipoHistorico
    }).then(response => {
      this.listarHistorico();
      this.fecharModal('displayHistoricoIncluir');
      this.toast.show({severity:'success', summary: 'Atividades', detail:'Histórico incluído com sucesso', life: 4000});
    });
    this.setState({openSpinner: false});
  }

  abrirModalDescricao(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  listarStatusAtividadeAlterarAtividade = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.statusAtividadeService.listarStatus(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({statusAtividade: response.data});
        
        this.setState({kanbanAtivoLabel: response.data[0].status});
        this.setState({kanbanAtivoExibir: response.data[0].exibir});

        this.setState({kanbanAguardandoLabel: response.data[1].status});
        this.setState({kanbanAguardandoExibir: response.data[1].exibir});

        this.setState({kanbanCienteLabel: response.data[3].status});
        this.setState({kanbanCienteExibir: response.data[3].exibir});

        this.setState({kanbanConcluidoLabel: response.data[4].status});
        this.setState({kanbanConcluidoExibir: response.data[4].exibir});

        this.setState({kanbanFazendoLabel: response.data[5].status});
        this.setState({kanbanFazendoExibir: response.data[5].exibir});

      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Status de Atividade', detail:`${this.state.detail}`, life: 4000});
      });
  }

  consultarGrupoTrabalhoPai = async (codigo) => {
    await this.grupoTrabalhoService.consultarGrupo(codigo)
      .then(response => {
        this.setState({selectGrupo: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Relatório de Atividades', detail:'Erro ao consultar Grupo de Trabalho', life: 4000});
      })
  }

  consultarSubGrupos = async(codigo) => {
    await this.grupoTrabalhoService.listarSubGrupos(codigo)
      .then(response => {
        this.setState({subGrupos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Relatório de Atividades', detail:'Erro ao carregar Sub-Grupos de Trabalho', life: 4000});
      })
  }

  consultarGruposTrabalho = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.grupoTrabalhoService.listarGruposUsuario(usuarioLogado.codigo)
      .then(response => {
        this.setState({grupos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Relatório de Atividades', detail:'Erro ao carregar Grupos de Trabalhos do usuário', life: 4000});
      })
  }

  listarArquivosAtividade = async () => {
    await this.arquivoAtividadeService.listarArquivos(this.state.atividade.codigo)
      .then(response => {
        this.setState({arquivos: response.data});
        if(response.data.length > 0) {
          this.setState({exibirLinkAnexo: 'block'});
        } else {
          this.setState({exibirLinkAnexo: 'none'});
        }
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarResponsaveis = async () => {
    await this.atividadeService.consultarUsuariosAtividade(this.state.codigo, 'R')
      .then(response => {
        this.setState({responsaveisLista: response.data});
        this.setState({quantidadeResponsaveis: 'Responsaveis da Atividade ( ' + this.state.responsaveisLista.length + ' )'});
        this.listarResponsaveis(); 
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Relatório de Atividades', detail:'Erro ao listar responsáveis da atividade', life: 4000});
      })
  }

  consultarInteressados = async () => {
    await this.atividadeService.consultarUsuariosAtividade(this.state.codigo, 'I')
      .then(response => {
        this.setState({interessadosLista: response.data});
        if(this.state.interessadosLista.length == 0) {
          this.setState({quantidadeInteressados: 'Atividade sem interessados'});
        } else {
          this.setState({quantidadeInteressados: 'Interessados da Atividade ( ' + this.state.interessadosLista.length + ' )'});
        }
        this.listarInteressados();
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Relatório de Atividades', detail:'Erro ao listar responsáveis da atividade', life: 4000});
      })
  }

  abrirModalAtividadeAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  acoesAtividade(rowData) {
    return(
      <React.Fragment>
        <a onClick={() => this.consultarAtividade(rowData)} style={{cursor: 'pointer', color: 'blue'}}>{rowData.titulo}</a>
      </React.Fragment>
    );
  }

  renderFooterAtividade(name) {
    return (
        <div className="left">
            <Button label="Alterar" 
                    onClick={this.alterarAtividade}
                    className="p-button-primary p-button-text"/>
            &nbsp;
            <Button label="Anexar" 
                    icon="pi pi-paperclip"
                    onClick={() => this.abrirModalArquivosAnexos('displayArquivosAnexados')}
                    className="p-button-help p-button-text"/>
            &nbsp;
            <Button label="Histórico" 
                    icon="pi pi-history"
                    className="p-button-help p-button-text"
                    onClick={this.consultarHistorico}/>
            &nbsp;
            <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalAtividade(name)}/>
        </div>
    );
  }

  listarResponsaveis = async() => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividade(this.state.selectGrupo.codigo)
      .then(response => {
        this.setState({responsaveis: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Relatório de Atividades', detail:'Erro ao listar responśaveis', life: 4000});
      })
  }

  listarInteressados = async() => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividade(this.state.selectGrupo.codigo)
      .then(response => {
        this.setState({interessados: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Relatório de Atividades', detail:'Erro ao listar interssados', life: 4000});
      })
  }

  async consultarAtividade(atividade) {
    const usuarioLogado = this.context.usuarioAutenticado
    this.setState({openSpinner: true});
    await this.atividadeService.consultarAtividade(atividade.codigo,usuarioLogado.codigo)
      .then(response => {
        this.setState({atividade: response.data});
        this.setState({codigo: response.data.codigo});
        this.setState({titulo: response.data.titulo});
        this.setState({descricao: response.data.descricao});
        this.consultarGrupoTrabalhoPai(response.data.subGrupo.grupoPai);
        this.consultarSubGrupos(response.data.subGrupo.grupoPai);
        this.setState({tipoAtividadeAlterar: response.data.tipo});
        this.listarFases();
        this.consultarGruposTrabalho();
        this.setState({fase: response.data.fase});
        this.setState({selectSubGrupo: response.data.subGrupo});
        if(response.data.processo != null) {
          this.setState({partes: atividade.partes});
          if(atividade.favorito != null && atividade.favorito != 'N') {
            this.setState({favorito: 'p-button-rounded p-button-danger'});
            this.setState({titleFavorito: 'Processo classificado como meus favoritos'});
            this.setState({exibirFavorito: 'hide'});
          } else {
            this.setState({favorito: 'p-button-rounded p-button-secondary'});
            this.setState({titleFavorito: 'Este processo não está classificado como meus favoritos'});
            this.setState({exibirFavorito: 'none'});
          }
          if(atividade.importante != null && atividade.importante != 'N') {
            this.setState({importante: 'p-button-rounded p-button-warning'});
            this.setState({titileImportante: 'Processo importante para empresa'});
            this.setState({exibirImportanteEmpresa: 'hide'});
          } else {
            this.setState({importante: 'p-button-rounded p-button-secondary'});
            this.setState({titileImportante: 'Processo normal'});
            this.setState({exibirImportanteEmpresa: 'none'});
          }
          this.setState({processo: response.data.processo});
          this.setState({processoPesquisado: response.data.processo.nrCnj});
          this.setState({processoPesquisadoVisivel: 'block'});
          this.setState({sizePesquisa: 'col-sm-5'});
          this.setState({campoPesquisaProcesso: 'none'});
          if(response.data.processo.nrCnj != null && response.data.processo.nrCnj != '') {
            var cnjMascarado = response.data.processo.nrCnj.substring(0, 7);
                cnjMascarado = cnjMascarado + "-" + response.data.processo.nrCnj.substring(7, 9);
                cnjMascarado = cnjMascarado + "." + response.data.processo.nrCnj.substring(9, 13);
                cnjMascarado = cnjMascarado + "." + response.data.processo.nrCnj.substring(13, 14);
                cnjMascarado = cnjMascarado + "." + response.data.processo.nrCnj.substring(14, 16);
                cnjMascarado = cnjMascarado + "." + response.data.processo.nrCnj.substring(16, 20);
            this.setState({processoPesquisado: cnjMascarado});
          } else {
            this.setState({processoPesquisado: response.data.processo.nrProcesso});
          }
          this.setState({escondeBotalExcluirPesquisa: {
            display: 'block'
          }});
          this.setState({bloqueiaGrupo: true});
        } else {
          this.setState({sizePesquisa: 'col-sm-12'});
          this.setState({bloqueiaGrupo: false});
          this.setState({processoPesquisado: ''});
          this.setState({processoPesquisadoVisivel: 'none'});
          this.setState({campoPesquisaProcesso: 'block'})
          this.setState({escondeBotalExcluirPesquisa: {
            display: 'none'
          }});
          this.setState({pesquisaProcesso: ''});
        }
        var dataLimite = new Date(response.data.dtLimite);
        dataLimite.setDate(dataLimite.getDate() + 1)
        this.setState({dtLimite: new Date(Date.parse(dataLimite))});
        this.setState({hora: response.data.hora});
        if(response.data.dtFatal != null) {
          var dataFatal = new Date(response.data.dtFatal);
          dataFatal.setDate(dataFatal.getDate() + 1)
          this.setState({dtFatal: new Date(Date.parse(dataFatal))});
        } else {
          this.setState({dtFatal: ''});
        }
        
        this.setState({statusAtividadeAlterar: response.data.status})
      }
    ).catch(error => {
      this.setState({openSpinner: false});
      this.setState(error.response.data)
      this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
    });

    await this.listarArquivosAtividade();
    await this.consultarResponsaveis();
    await this.consultarInteressados();   
    await this.consultarGruposTrabalho(); 
    this.abrirModalAtividadeAlterar('displayAtividade');
    this.setState({openSpinner: false});
  }

  alterarAtividade = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.titulo == '') {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o título da Atividade', life: 4000});
      return false;
    }

    if(this.state.selectGrupo == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.selectSubGrupo == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o Sub-Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.responsaveisLista == null || this.state.responsaveisLista.size == 0) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'A atividade precisa de ao menos um responsável', life: 4000});
      return false;
    }

    if(this.state.dtLimite == '') {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe a Data Limite', life: 4000});
      return false;
    }

    let tipoTarefa = '';
    if(this.state.dtLimite != '' && this.state.dtLimite != null) {
      var date = this.state.dtLimite;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != '' && this.state.hora != null) {
        var dataFormatadaDataLimite =  year+"-"+month+"-"+day+ " " + this.state.hora + ":00";
        tipoTarefa = 'A';
      } else {
        var dataFormatadaDataLimite =  year+"-"+month+"-"+day+" 00:00:00";
        tipoTarefa = 'T';
      }
    }

    var dataFormatadaDataFatal = "";
    if(this.state.dtFatal != '' && this.state.dtFatal != null) {
      var date = this.state.dtFatal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != null && this.state.hora != '') {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day+ " " + this.state.hora + ":00";
      } else {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day+" 00:00:00";
      }
    }

    const atividadeAlterar = {
      atividade: {
        codigo: this.state.atividade.codigo,
        titulo: this.state.titulo,
        tipo: tipoTarefa,
        descricao: this.state.descricao,
        usuario: usuarioLogado,
        processo: this.state.processo,
        dtLimite: dataFormatadaDataLimite,
        dtFatal: dataFormatadaDataFatal,
        status: this.state.statusAtividadeAlterar,
        subGrupo: this.state.selectSubGrupo
      },
      responsaveis: this.state.responsaveisLista,
      interessados: this.state.interessadosLista
    }

    var hora = "00:00";
    if(this.state.hora != null) {
      hora = this.state.hora;
    }

    this.setState({openSpinner: true});
    await this.atividadeService.alterarAtividade(this.state.atividade.dtLimite + " " + hora + ":00",
      this.state.atividade.status.codigo, usuarioLogado.codigo,atividadeAlterar
      ).then(response => {
        this.toast.show({severity:'success', summary: 'Atividades', detail:'Atividade alterada com sucesso', life: 4000});
        this.fecharModalAtividade('displayAtividade');
      }).catch(error => {
        this.setState(error.response.data);
        this.fecharModalAtividade('displayAtividade');
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 8000});
      });
      this.setState({openSpinner: false});
  }

  consultarRelatorioGerado = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.relatorioAtividadeService.consultarRelatorioGerado(usuarioLogado.codigo)
      .then(response => {
        this.setState({relatorioGerado: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  acoes(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-cloud-download" className="p-button-rounded p-button-text" 
                tooltip="Download"
                onClick={() => this.download(rowData)}
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-send" className="p-button-rounded p-button-text"
                tooltip="Enviar Relatório"
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Relatório"
                onClick={() => this.confirmaExclusaoRelatorio(rowData)}
                tooltipOptions={{position: 'top'}} />
      </React.Fragment>
    );
  }

  listarGruposTrabalho = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.grupoTrabalhoService.listarGrupos(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({gruposTrabalho: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarStatusAtividade = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.statusAtividadeService.listarStatus(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({statusLista: response.data});
        this.setState({status: response.data});
      }).catch(error => {
        console.log(error);
        //this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarStatusAtividadeMassa = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.statusAtividadeService.listarStatus(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({statusLista: response.data});
      }).catch(error => {
        console.log(error);
        //this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarUsuarios = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.usuarioService.listarUsuariosEmpresa(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({usuarios: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  emitirRelatorio = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    //Data Limite
    var dataLimiteFormatInicial = '0';
    var dataLimiteFormatFinal = '0';
    if(this.state.dataLimiteInicial != '' && this.state.dataLimiteInicial != null &&
       this.state.dataLimiteFinal != '' && this.state.dataLimiteFinal != null) {
        var dateInicial = this.state.dataLimiteInicial;
        var monthInicial = this.pad2(dateInicial.getMonth()+1);//months (0-11)
        var dayInicial = this.pad2(dateInicial.getDate());//day (1-31)
        var yearInicial= dateInicial.getFullYear();
        dataLimiteFormatInicial = yearInicial+"-"+monthInicial+"-"+dayInicial;
        var dateFinal = this.state.dataLimiteFinal;
        var monthFinal = this.pad2(dateFinal.getMonth()+1);//months (0-11)
        var dayFinal = this.pad2(dateFinal.getDate());//day (1-31)
        var yearFinal= dateFinal.getFullYear();
        dataLimiteFormatFinal = yearFinal+"-"+monthFinal+"-"+dayFinal;
    } else {
      dataLimiteFormatInicial = '0';
      dataLimiteFormatFinal = '0';
    }
    //Data de Conclusão
    var dataConcluidoFormatInicial = '0';
    var dataConcluidoFormatFinal = '0';
    if(this.state.dataConcluidoInicial != '' && this.state.dataConcluidoInicial != null &&
       this.state.dataConcluidoFinal != '' && this.state.dataConcluidoFinal != null) {
        var dateInicial = this.state.dataConcluidoInicial;
        var monthInicial = this.pad2(dateInicial.getMonth()+1);//months (0-11)
        var dayInicial = this.pad2(dateInicial.getDate());//day (1-31)
        var yearInicial= dateInicial.getFullYear();
        dataConcluidoFormatInicial = yearInicial+"-"+monthInicial+"-"+dayInicial;
        var dateFinal = this.state.dataConcluidoFinal;
        var monthFinal = this.pad2(dateFinal.getMonth()+1);//months (0-11)
        var dayFinal = this.pad2(dateFinal.getDate());//day (1-31)
        var yearFinal= dateFinal.getFullYear();
        dataConcluidoFormatFinal = yearFinal+"-"+monthFinal+"-"+dayFinal;
    } else {
      dataConcluidoFormatInicial = '0';
      dataConcluidoFormatFinal = '0';
    }
    //Data de Cadastro
    var dataCadastroFormatInicial = '0';
    var dataCadastroFormatFinal = '0';
    if(this.state.dataCadastroInicial != '' && this.state.dataCadastroInicial != null &&
       this.state.dataCadastroFinal != '' && this.state.dataCadastroFinal != null) {
        var dateInicial = this.state.dataCadastroInicial;
        var monthInicial = this.pad2(dateInicial.getMonth()+1);//months (0-11)
        var dayInicial = this.pad2(dateInicial.getDate());//day (1-31)
        var yearInicial= dateInicial.getFullYear();
        dataCadastroFormatInicial = yearInicial+"-"+monthInicial+"-"+dayInicial;
        var dateFinal = this.state.dataCadastroFinal;
        var monthFinal = this.pad2(dateFinal.getMonth()+1);//months (0-11)
        var dayFinal = this.pad2(dateFinal.getDate());//day (1-31)
        var yearFinal= dateFinal.getFullYear();
        dataCadastroFormatFinal = yearFinal+"-"+monthFinal+"-"+dayFinal;
    } else {
      dataCadastroFormatInicial = '0';
      dataCadastroFormatFinal = '0';
    }

    //Prazo Fatal
    var dataFatalFormatInicial = '0';
    var dataFatalFormatFinal = '0';
    if(this.state.dataFatalInicial != '' && this.state.dataFatalInicial != null &&
       this.state.dataFatalFinal != '' && this.state.dataFatalFinal != null) {
        var dateInicial = this.state.dataFatalInicial;
        var monthInicial = this.pad2(dateInicial.getMonth()+1);//months (0-11)
        var dayInicial = this.pad2(dateInicial.getDate());//day (1-31)
        var yearInicial= dateInicial.getFullYear();
        dataFatalFormatInicial = yearInicial+"-"+monthInicial+"-"+dayInicial;
        var dateFinal = this.state.dataFatalFinal;
        var monthFinal = this.pad2(dateFinal.getMonth()+1);//months (0-11)
        var dayFinal = this.pad2(dateFinal.getDate());//day (1-31)
        var yearFinal= dateFinal.getFullYear();
        dataFatalFormatFinal = yearFinal+"-"+monthFinal+"-"+dayFinal;
    } else {
      dataFatalFormatInicial = '0';
      dataFatalFormatFinal = '0';
    }

    //Data de Alteração
    var dataAlteracaoFormatInicial = '0';
    var dataAlteracaoFormatFinal = '0';
    if(this.state.dataAlteracaoInicial != '' && this.state.dataAlteracaoInicial != null &&
       this.state.dataAlteracaoFinal == '' || this.state.dataAlteracaoFinal == null) {
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Você precisa preencher os dois campos de datas de alteraçãoa para a pesquisa', life: 8000});
    }

    if(this.state.dataAlteracaoInicial == '' || this.state.dataAlteracaoInicial == null &&
       this.state.dataAlteracaoFinal != '' && this.state.dataAlteracaoFinal != null) {
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Você precisa preencher os dois campos de datas de alteraçãoa para a pesquisa', life: 8000});
    }

    if(this.state.dataAlteracaoInicial != '' && this.state.dataAlteracaoInicial != null &&
       this.state.dataAlteracaoFinal != '' && this.state.dataAlteracaoFinal != null) {
        var dateInicial = this.state.dataAlteracaoInicial;
        var monthInicial = this.pad2(dateInicial.getMonth()+1);//months (0-11)
        var dayInicial = this.pad2(dateInicial.getDate());//day (1-31)
        var yearInicial= dateInicial.getFullYear();
        dataAlteracaoFormatInicial = yearInicial+"-"+monthInicial+"-"+dayInicial;
        var dateFinal = this.state.dataAlteracaoFinal;
        var monthFinal = this.pad2(dateFinal.getMonth()+1);//months (0-11)
        var dayFinal = this.pad2(dateFinal.getDate());//day (1-31)
        var yearFinal= dateFinal.getFullYear();
        dataAlteracaoFormatFinal = yearFinal+"-"+monthFinal+"-"+dayFinal;
    } else {
      dataAlteracaoFormatInicial = '0';
      dataAlteracaoFormatFinal = '0';
    }

    //Usuários das Atividades
    var responsavel = '0';
    var interessado = '0';
    if(this.state.usuario != null && this.state.tipo == null) {
      this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Você selecionaou um usuário, escolha o tipo', life: 8000});
      return;
    }

    if(this.state.usuario != null && this.state.tipo != null) {
      if(this.state.tipo.codigo == 'R') {
        responsavel = this.state.usuario.codigo;
      } else {
        interessado = this.state.usuario.codigo;
      }
    }

    //Grupo de Trabalho
    var grupoTrabalho = '0';
    if(this.state.grupoTrabalho != null) {
      grupoTrabalho = this.state.grupoTrabalho.codigo;
    }

    //Status
    var status = '0';
    if(this.state.status != null) {
      var contador = 0;
      for(let i = 0; i < this.state.status.length; i++) {
        if(contador < this.state.status.length - 1) {
          status = status + this.state.status[i].codigo + ',';
        } else {
          status = status + this.state.status[i].codigo;
        }
        contador++;
      }
    }

    //Tipo de Atividade
    var tipoAtividade = '0';
    if(this.state.tipoAtividade != null) {
      tipoAtividade = this.state.tipoAtividade.codigo;
    }

    //Classificação e Ordenação
    var classificacao = '1';
    var ordenacao = '1';
    if(this.state.classificacao != null) {
      classificacao = this.state.classificacao.codigo;
    }

    if(this.state.ordenacao != null) {
      ordenacao = this.state.ordenacao.codigo;
    }

    this.setState({caminhoRelatorio: `#/relatorioAtividadeResult/${usuarioLogado.empresa.codigo}/${usuarioLogado.codigo}/${dataLimiteFormatInicial}/${dataLimiteFormatFinal}/${dataConcluidoFormatInicial}/${dataConcluidoFormatFinal}/${dataCadastroFormatInicial}/${dataCadastroFormatFinal}/${dataFatalFormatInicial}/${dataFatalFormatFinal}/${responsavel}/${interessado}/${grupoTrabalho}/${status}/${tipoAtividade}/${classificacao}/${ordenacao}`});
  
  }

  exportarRelatorio = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    //Data Limite
    var dataLimiteFormatInicial = '0';
    var dataLimiteFormatFinal = '0';
    if(this.state.dataLimiteInicial != '' && this.state.dataLimiteInicial != null &&
       this.state.dataLimiteFinal != '' && this.state.dataLimiteFinal != null) {
        var dateInicial = this.state.dataLimiteInicial;
        var monthInicial = this.pad2(dateInicial.getMonth()+1);//months (0-11)
        var dayInicial = this.pad2(dateInicial.getDate());//day (1-31)
        var yearInicial= dateInicial.getFullYear();
        dataLimiteFormatInicial = yearInicial+"-"+monthInicial+"-"+dayInicial;
        var dateFinal = this.state.dataLimiteFinal;
        var monthFinal = this.pad2(dateFinal.getMonth()+1);//months (0-11)
        var dayFinal = this.pad2(dateFinal.getDate());//day (1-31)
        var yearFinal= dateFinal.getFullYear();
        dataLimiteFormatFinal = yearFinal+"-"+monthFinal+"-"+dayFinal;
    } else {
      dataLimiteFormatInicial = '0';
      dataLimiteFormatFinal = '0';
    }

    if((this.state.dataLimiteInicial != '' && this.state.dataLimiteInicial != null) &&
       (this.state.dataLimiteFinal == '' || this.state.dataLimiteFinal == null)) {
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Vocẽ precisa preencher os dois campos de data de limite', life: 8000});
        return;
    }

    if((this.state.dataLimiteInicial == '' || this.state.dataLimiteInicial == null) &&
       (this.state.dataLimiteFinal != '' && this.state.dataLimiteFinal != null)) {
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Vocẽ precisa preencher os dois campos de data de limite', life: 8000});
        return;
    }

    //Data de Conclusão
    var dataConcluidoFormatInicial = '0';
    var dataConcluidoFormatFinal = '0';
    if(this.state.dataConcluidoInicial != '' && this.state.dataConcluidoInicial != null &&
       this.state.dataConcluidoFinal != '' && this.state.dataConcluidoFinal != null) {
        var dateInicial = this.state.dataConcluidoInicial;
        var monthInicial = this.pad2(dateInicial.getMonth()+1);//months (0-11)
        var dayInicial = this.pad2(dateInicial.getDate());//day (1-31)
        var yearInicial= dateInicial.getFullYear();
        dataConcluidoFormatInicial = yearInicial+"-"+monthInicial+"-"+dayInicial;
        var dateFinal = this.state.dataConcluidoFinal;
        var monthFinal = this.pad2(dateFinal.getMonth()+1);//months (0-11)
        var dayFinal = this.pad2(dateFinal.getDate());//day (1-31)
        var yearFinal= dateFinal.getFullYear();
        dataConcluidoFormatFinal = yearFinal+"-"+monthFinal+"-"+dayFinal;
    } else {
      dataConcluidoFormatInicial = '0';
      dataConcluidoFormatFinal = '0';
    }

    if((this.state.dataConcluidoInicial != '' && this.state.dataConcluidoInicial != null) &&
       (this.state.dataConcluidoFinal == '' || this.state.dataConcluidoFinal == null)) {
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Vocẽ precisa preencher os dois campos de data de conclusão', life: 8000});
        return;
    }

    if((this.state.dataConcluidoInicial == '' || this.state.dataConcluidoInicial == null) &&
       (this.state.dataConcluidoFinal != '' && this.state.dataConcluidoFinal != null)) {
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Vocẽ precisa preencher os dois campos de data de conclusão', life: 8000});
        return;
    }

    //Data de Cadastro
    var dataCadastroFormatInicial = '0';
    var dataCadastroFormatFinal = '0';
    if(this.state.dataCadastroInicial != '' && this.state.dataCadastroInicial != null &&
       this.state.dataCadastroFinal != '' && this.state.dataCadastroFinal != null) {
        var dateInicial = this.state.dataCadastroInicial;
        var monthInicial = this.pad2(dateInicial.getMonth()+1);//months (0-11)
        var dayInicial = this.pad2(dateInicial.getDate());//day (1-31)
        var yearInicial= dateInicial.getFullYear();
        dataCadastroFormatInicial = yearInicial+"-"+monthInicial+"-"+dayInicial;
        var dateFinal = this.state.dataCadastroFinal;
        var monthFinal = this.pad2(dateFinal.getMonth()+1);//months (0-11)
        var dayFinal = this.pad2(dateFinal.getDate());//day (1-31)
        var yearFinal= dateFinal.getFullYear();
        dataCadastroFormatFinal = yearFinal+"-"+monthFinal+"-"+dayFinal;
    } else {
      dataCadastroFormatInicial = '0';
      dataCadastroFormatFinal = '0';
    }

    if((this.state.dataCadastroInicial != '' && this.state.dataCadastroInicial != null) &&
       (this.state.dataCadastroFinal == '' || this.state.dataCadastroFinal == null)) {
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Vocẽ precisa preencher os dois campos de data de cadastro', life: 8000});
        return;
    }

    if((this.state.dataCadastroInicial == '' || this.state.dataCadastroInicial == null) &&
       (this.state.dataCadastroFinal != '' && this.state.dataCadastroFinal != null)) {
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Vocẽ precisa preencher os dois campos de data de cadastro', life: 8000});
        return;
    }

    //Data de Alteração
    var dataAlteracaoFormatInicial = '0';
    var dataAlteracaoFormatFinal = '0';
    if(this.state.dataAlteracaoInicial != '' && this.state.dataAlteracaoInicial != null &&
       this.state.dataAlteracaoFinal != '' && this.state.dataAlteracaoFinal != null) {
        var dateInicial = this.state.dataAlteracaoInicial;
        var monthInicial = this.pad2(dateInicial.getMonth()+1);//months (0-11)
        var dayInicial = this.pad2(dateInicial.getDate());//day (1-31)
        var yearInicial= dateInicial.getFullYear();
        dataAlteracaoFormatInicial = yearInicial+"-"+monthInicial+"-"+dayInicial;
        var dateFinal = this.state.dataAlteracaoFinal;
        var monthFinal = this.pad2(dateFinal.getMonth()+1);//months (0-11)
        var dayFinal = this.pad2(dateFinal.getDate());//day (1-31)
        var yearFinal= dateFinal.getFullYear();
        dataAlteracaoFormatFinal = yearFinal+"-"+monthFinal+"-"+dayFinal;
    } else {
      dataAlteracaoFormatInicial = '0';
      dataAlteracaoFormatFinal = '0';
    }

    if((this.state.dataAlteracaoInicial != '' && this.state.dataAlteracaoInicial != null) &&
       (this.state.dataAlteracaoFinal == '' || this.state.dataAlteracaoFinal == null)) {
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Você precisa preencher os dois campos de datas de alteração para a pesquisa', life: 8000});
        return;
      }

    if((this.state.dataAlteracaoInicial == '' || this.state.dataAlteracaoInicial == null) &&
       (this.state.dataAlteracaoFinal != '' && this.state.dataAlteracaoFinal != null)) {
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Você precisa preencher os dois campos de datas de alteração para a pesquisa', life: 8000});
        return;
    }

    //Prazo Fatal
    var dataFatalFormatInicial = '0';
    var dataFatalFormatFinal = '0';
    if(this.state.dataFatalInicial != '' && this.state.dataFatalInicial != null &&
       this.state.dataFatalFinal != '' && this.state.dataFatalFinal != null) {
        var dateInicial = this.state.dataFatalInicial;
        var monthInicial = this.pad2(dateInicial.getMonth()+1);//months (0-11)
        var dayInicial = this.pad2(dateInicial.getDate());//day (1-31)
        var yearInicial= dateInicial.getFullYear();
        dataFatalFormatInicial = yearInicial+"-"+monthInicial+"-"+dayInicial;
        var dateFinal = this.state.dataFatalFinal;
        var monthFinal = this.pad2(dateFinal.getMonth()+1);//months (0-11)
        var dayFinal = this.pad2(dateFinal.getDate());//day (1-31)
        var yearFinal= dateFinal.getFullYear();
        dataFatalFormatFinal = yearFinal+"-"+monthFinal+"-"+dayFinal;
    } else {
      dataFatalFormatInicial = '0';
      dataFatalFormatFinal = '0';
    }

    if((this.state.dataFatalInicial != '' && this.state.dataFatalInicial != null) &&
       (this.state.dataFatalFinal == '' || this.state.dataFatalFinal == null)) {
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Você precisa preencher os dois campos de datas de prazo fatal para a pesquisa', life: 8000});
        return;
      }

    if((this.state.dataFatalInicial == '' || this.state.dataFatalInicial == null) &&
       (this.state.dataFatalFinal != '' && this.state.dataFatalFinal != null)) {
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Você precisa preencher os dois campos de datas de prazo fatal para a pesquisa', life: 8000});
        return;
    }

    //Usuários das Atividades
    var responsavel = '0';
    var interessado = '0';
    if(this.state.usuario != null && this.state.tipo == null) {
      this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Você selecionaou um usuário, escolha o tipo', life: 8000});
      return;
    }

    if(this.state.usuario != null && this.state.tipo != null) {
      if(this.state.tipo.codigo == 'R') {
        responsavel = this.state.usuario.codigo;
      } else {
        interessado = this.state.usuario.codigo;
      }
    }

    //Grupo de Trabalho
    var grupoTrabalho = '0';
    if(this.state.grupoTrabalho != null) {
      grupoTrabalho = this.state.grupoTrabalho.codigo;
    }

    //Status
    var status = '0';
    if(this.state.status != null) {
      var contador = 0;
      for(let i = 0; i < this.state.status.length; i++) {
        if(contador < this.state.status.length - 1) {
          status = status + this.state.status[i].codigo + ',';
        } else {
          status = status + this.state.status[i].codigo;
        }
        contador++;
      }
    }

    //Tipo de Atividade
    var tipoAtividade = '0';
    if(this.state.tipoAtividade != null) {
      tipoAtividade = this.state.tipoAtividade.codigo;
    }

    //Classificação e Ordenação
    var classificacao = '1';
    var ordenacao = '1';
    if(this.state.classificacao != null) {
      classificacao = this.state.classificacao.codigo;
    }

    if(this.state.ordenacao != null) {
      ordenacao = this.state.ordenacao.codigo;
    }

    if(dataLimiteFormatInicial == '0' && dataLimiteFormatFinal == '0' &&
       dataCadastroFormatInicial == '0' && dataCadastroFormatFinal == '0' &&
       dataConcluidoFormatInicial == '0' && dataConcluidoFormatFinal == '0' &&
       dataAlteracaoFormatInicial == '0' && dataAlteracaoFormatFinal == '0' &&
       responsavel == '0' && interessado == '0' && grupoTrabalho == '0' &&
       status == '0' && tipoAtividade == '0') {
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Nenhum filtro foi selecionado', life: 5000});
        this.setState({openSpinner: false});
        return;
    }

    const filtro = {
      empresa: usuarioLogado.empresa.codigo,
      usuario: usuarioLogado.codigo,
      dataLimiteInicial: dataLimiteFormatInicial,
      dataLimiteFinal: dataLimiteFormatFinal,
      dataConcluidoInicial: dataConcluidoFormatInicial,
      dataConcluidoFinal: dataConcluidoFormatFinal,
      dataCriacaoInicial: dataCadastroFormatInicial,
      dataCriacaoFinal: dataCadastroFormatFinal,
      dataAlteracaoInicial: dataAlteracaoFormatInicial,
      dataAlteracaoFinal: dataAlteracaoFormatFinal,
      dataFatalInicial: dataFatalFormatInicial,
      dataFatalFinal: dataFatalFormatFinal,
      responsavel: responsavel,
      interessado: interessado,
      grupoTrabalho: grupoTrabalho,
      status: status,
      tipoAtividade: tipoAtividade,
      classificacao: classificacao,
      ordenacao: ordenacao
    }
    this.setState({openSpinner: true});
    await this.relatorioAtividadeService.exportarRelatorio(filtro)
      .then(response => {
        this.download(response.data);
        this.consultarRelatorioGerado();
        this.toast.show({severity:'success', summary: 'Relatórios de Atividades', detail:'Relatório gerado com sucesso', life: 4000});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:`${this.state.detail}`, life: 4000});
      })
      this.setState({openSpinner: false});
  }

  download = async (relatorio) => {
    await this.consultarRelatorio(relatorio);
    await this.relatorioAtividadeService.download(relatorio.codigo)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.state.relatorioArquivo.relatorio); //or any other extension
        document.body.appendChild(link);
        link.click();
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Relatório de Atividades', detail:'Erro executar download de relatório', life: 4000});
      })
  }

  consultarRelatorio = async (relatorio) => {
    await this.relatorioAtividadeService.consultarRelatorio(relatorio.codigo)
      .then(response => {
        this.setState({relatorioArquivo: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Relatório de Atividades', detail:'Erro ao consultar Relatório', life: 4000});
      })
  }

  refreshPage = () => {
    window.location.reload();
  }

  consultarAtividades = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    //Data Limite
    var dataLimiteFormatInicial = '0';
    var dataLimiteFormatFinal = '0';
    if(this.state.dataLimiteInicial != '' && this.state.dataLimiteInicial != null &&
       this.state.dataLimiteFinal != '' && this.state.dataLimiteFinal != null) {
        var dateInicial = this.state.dataLimiteInicial;
        var monthInicial = this.pad2(dateInicial.getMonth()+1);//months (0-11)
        var dayInicial = this.pad2(dateInicial.getDate());//day (1-31)
        var yearInicial= dateInicial.getFullYear();
        dataLimiteFormatInicial = yearInicial+"-"+monthInicial+"-"+dayInicial;
        var dateFinal = this.state.dataLimiteFinal;
        var monthFinal = this.pad2(dateFinal.getMonth()+1);//months (0-11)
        var dayFinal = this.pad2(dateFinal.getDate());//day (1-31)
        var yearFinal= dateFinal.getFullYear();
        dataLimiteFormatFinal = yearFinal+"-"+monthFinal+"-"+dayFinal;
    } else {
      dataLimiteFormatInicial = '0';
      dataLimiteFormatFinal = '0';
    }

    if((this.state.dataLimiteInicial != '' && this.state.dataLimiteInicial != null) &&
       (this.state.dataLimiteFinal == '' || this.state.dataLimiteFinal == null)) {
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Vocẽ precisa preencher os dois campos de data de limite', life: 8000});
        return;
    }

    if((this.state.dataLimiteInicial == '' || this.state.dataLimiteInicial == null) &&
       (this.state.dataLimiteFinal != '' && this.state.dataLimiteFinal != null)) {
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Vocẽ precisa preencher os dois campos de data de limite', life: 8000});
        return;
    }

    //Prazo Fatal
    var dataFatalFormatInicial = '0';
    var dataFatalFormatFinal = '0';
  
    if(this.state.dataFatalInicial != '' && this.state.dataFatalInicial != null &&
       this.state.dataFatalFinal != '' && this.state.dataFatalFinal != null) {
        var dateInicial = this.state.dataFatalInicial;
        var monthInicial = this.pad2(dateInicial.getMonth()+1);//months (0-11)
        var dayInicial = this.pad2(dateInicial.getDate());//day (1-31)
        var yearInicial= dateInicial.getFullYear();
        dataFatalFormatInicial = yearInicial+"-"+monthInicial+"-"+dayInicial;
        var dateFinal = this.state.dataFatalFinal;
        var monthFinal = this.pad2(dateFinal.getMonth()+1);//months (0-11)
        var dayFinal = this.pad2(dateFinal.getDate());//day (1-31)
        var yearFinal= dateFinal.getFullYear();
        dataFatalFormatFinal = yearFinal+"-"+monthFinal+"-"+dayFinal;
    } else {
      dataFatalFormatInicial = '0';
      dataFatalFormatFinal = '0';
    }

    if((this.state.dataFatalInicial != '' && this.state.dataFatalInicial != null) &&
       (this.state.dataFatalFinal == '' || this.state.dataFatalFinal == null)) {
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Vocẽ precisa preencher os dois campos de prazo fatal', life: 8000});
        return;
    }

    if((this.state.dataFatalInicial == '' || this.state.dataFatalInicial == null) &&
       (this.state.dataFatalFinal != '' && this.state.dataFatalFinal != null)) {
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Vocẽ precisa preencher os dois campos de prazo fatal', life: 8000});
        return;
    }

    //Data de Conclusão
    var dataConcluidoFormatInicial = '0';
    var dataConcluidoFormatFinal = '0';
    if(this.state.dataConcluidoInicial != '' && this.state.dataConcluidoInicial != null &&
       this.state.dataConcluidoFinal != '' && this.state.dataConcluidoFinal != null) {
        var dateInicial = this.state.dataConcluidoInicial;
        var monthInicial = this.pad2(dateInicial.getMonth()+1);//months (0-11)
        var dayInicial = this.pad2(dateInicial.getDate());//day (1-31)
        var yearInicial= dateInicial.getFullYear();
        dataConcluidoFormatInicial = yearInicial+"-"+monthInicial+"-"+dayInicial;
        var dateFinal = this.state.dataConcluidoFinal;
        var monthFinal = this.pad2(dateFinal.getMonth()+1);//months (0-11)
        var dayFinal = this.pad2(dateFinal.getDate());//day (1-31)
        var yearFinal= dateFinal.getFullYear();
        dataConcluidoFormatFinal = yearFinal+"-"+monthFinal+"-"+dayFinal;
    } else {
      dataConcluidoFormatInicial = '0';
      dataConcluidoFormatFinal = '0';
    }

    if((this.state.dataConcluidoInicial != '' && this.state.dataConcluidoInicial != null) &&
       (this.state.dataConcluidoFinal == '' || this.state.dataConcluidoFinal == null)) {
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Vocẽ precisa preencher os dois campos de data de conclusão', life: 8000});
        return;
    }

    if((this.state.dataConcluidoInicial == '' || this.state.dataConcluidoInicial == null) &&
       (this.state.dataConcluidoFinal != '' && this.state.dataConcluidoFinal != null)) {
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Vocẽ precisa preencher os dois campos de data de conclusão', life: 8000});
        return;
    }

    //Data de Cadastro
    var dataCadastroFormatInicial = '0';
    var dataCadastroFormatFinal = '0';
    if(this.state.dataCadastroInicial != '' && this.state.dataCadastroInicial != null &&
       this.state.dataCadastroFinal != '' && this.state.dataCadastroFinal != null) {
        var dateInicial = this.state.dataCadastroInicial;
        var monthInicial = this.pad2(dateInicial.getMonth()+1);//months (0-11)
        var dayInicial = this.pad2(dateInicial.getDate());//day (1-31)
        var yearInicial= dateInicial.getFullYear();
        dataCadastroFormatInicial = yearInicial+"-"+monthInicial+"-"+dayInicial;
        var dateFinal = this.state.dataCadastroFinal;
        var monthFinal = this.pad2(dateFinal.getMonth()+1);//months (0-11)
        var dayFinal = this.pad2(dateFinal.getDate());//day (1-31)
        var yearFinal= dateFinal.getFullYear();
        dataCadastroFormatFinal = yearFinal+"-"+monthFinal+"-"+dayFinal;
    } else {
      dataCadastroFormatInicial = '0';
      dataCadastroFormatFinal = '0';
    }

    if((this.state.dataCadastroInicial != '' && this.state.dataCadastroInicial != null) &&
       (this.state.dataCadastroFinal == '' || this.state.dataCadastroFinal == null)) {
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Vocẽ precisa preencher os dois campos de data de cadastro', life: 8000});
        return;
    }

    if((this.state.dataCadastroInicial == '' || this.state.dataCadastroInicial == null) &&
       (this.state.dataCadastroFinal != '' && this.state.dataCadastroFinal != null)) {
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Vocẽ precisa preencher os dois campos de data de cadastro', life: 8000});
        return;
    }

    //Data de Alteração
    var dataAlteracaoFormatInicial = '0';
    var dataAlteracaoFormatFinal = '0';
  
    if(this.state.dataAlteracaoInicial != '' && this.state.dataAlteracaoInicial != null &&
       this.state.dataAlteracaoFinal != '' && this.state.dataAlteracaoFinal != null) {
        var dateInicial = this.state.dataAlteracaoInicial;
        var monthInicial = this.pad2(dateInicial.getMonth()+1);//months (0-11)
        var dayInicial = this.pad2(dateInicial.getDate());//day (1-31)
        var yearInicial= dateInicial.getFullYear();
        dataAlteracaoFormatInicial = yearInicial+"-"+monthInicial+"-"+dayInicial;
        var dateFinal = this.state.dataAlteracaoFinal;
        var monthFinal = this.pad2(dateFinal.getMonth()+1);//months (0-11)
        var dayFinal = this.pad2(dateFinal.getDate());//day (1-31)
        var yearFinal= dateFinal.getFullYear();
        dataAlteracaoFormatFinal = yearFinal+"-"+monthFinal+"-"+dayFinal;
    } else {
      dataAlteracaoFormatInicial = '0';
      dataAlteracaoFormatFinal = '0';
    }

    if((this.state.dataAlteracaoInicial != '' && this.state.dataAlteracaoInicial != null) &&
       (this.state.dataAlteracaoFinal == '' || this.state.dataAlteracaoFinal == null)) {
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Vocẽ precisa preencher os dois campos de data de alteração', life: 8000});
        return;
    }

    if((this.state.dataAlteracaoInicial == '' || this.state.dataAlteracaoInicial == null) &&
       (this.state.dataAlteracaoFinal != '' && this.state.dataAlteracaoFinal != null)) {
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Vocẽ precisa preencher os dois campos de data de alteração', life: 8000});
        return;
    }

    //Usuários das Atividades
    var responsavel = '0';
    var interessado = '0';
    if(this.state.usuario != null && this.state.tipo == null) {
      this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Você selecionaou um usuário, escolha o tipo', life: 8000});
      return;
    }

    if(this.state.usuario != null && this.state.tipo != null) {
      if(this.state.tipo.codigo == 'R') {
        responsavel = this.state.usuario.codigo;
      } else {
        interessado = this.state.usuario.codigo;
      }
    }

    //Grupo de Trabalho
    var grupoTrabalho = '0';
    if(this.state.grupoTrabalho != null) {
      grupoTrabalho = this.state.grupoTrabalho.codigo;
    }

    //Status
    var status = '0';
    if(this.state.status != null) {
      var contador = 0;
      for(let i = 0; i < this.state.status.length; i++) {
        if(contador < this.state.status.length - 1) {
          status = status + this.state.status[i].codigo + ',';
        } else {
          status = status + this.state.status[i].codigo;
        }
        contador++;
      }
    }

    //Tipo de Atividade
    var tipoAtividade = '0';
    if(this.state.tipoAtividade != null) {
      tipoAtividade = this.state.tipoAtividade.codigo;
    }

    //Classificação e Ordenação
    var classificacao = '1';
    var ordenacao = '1';
    if(this.state.classificacao != null) {
      classificacao = this.state.classificacao.codigo;
    }

    if(this.state.ordenacao != null) {
      ordenacao = this.state.ordenacao.codigo;
    }

    if(dataLimiteFormatInicial == '0' && dataLimiteFormatFinal == '0' &&
       dataCadastroFormatInicial == '0' && dataCadastroFormatFinal == '0' &&
       dataConcluidoFormatInicial == '0' && dataConcluidoFormatFinal == '0' &&
       dataAlteracaoFormatInicial == '0' && dataAlteracaoFormatFinal == '0' &&
       dataFatalFormatInicial == '0' && dataFatalFormatFinal == '0' &&
       responsavel == '0' && interessado == '0' && grupoTrabalho == '0' &&
       tipoAtividade == '0') {
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:'Nenhum filtro foi selecionado', life: 5000});
        return;
    }

    const filtro = {
      empresa: usuarioLogado.empresa.codigo,
      usuario: usuarioLogado.codigo,
      dtLimiteInicial: dataLimiteFormatInicial,
      dtLimiteFinal: dataLimiteFormatFinal,
      dtConcluidoInicial: dataConcluidoFormatInicial,
      dtConcluidoFinal: dataConcluidoFormatFinal,
      dtCriacaoInicial: dataCadastroFormatInicial,
      dtCriacaoFinal: dataCadastroFormatFinal,
      dtAlteracaoInicial: dataAlteracaoFormatInicial,
      dtAlteracaoFinal: dataAlteracaoFormatFinal,
      dtFatalInicial: dataFatalFormatInicial,
      dtFatalFinal: dataFatalFormatFinal,
      responsavel: responsavel,
      interessado: interessado,
      grupoTrabalho: grupoTrabalho,
      status: status,
      tipoAtividade: tipoAtividade,
      classificacao: classificacao,
      ordenacao: ordenacao
    }
    this.setState({openSpinner: true});
    await this.relatorioAtividadeService.relatorioAtividade(filtro)
      .then(response => {
          this.setState({atividades: response.data});
          this.setState({totalAtividades: response.data.length});
          if(response.data.length > 0) {
            this.setState({exibirTelaConsulta: 'block'});
          }
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  limparConsulta = () => {
    this.setState({atividades: null});
    this.setState({dataLimiteInicial: ''});
    this.setState({dataLimiteFinal: ''});
    this.setState({dataCadastroInicial: ''});
    this.setState({dataCadastroFinal: ''});
    this.setState({dataConcluidoInicial: ''});
    this.setState({dataConcluidoFinal: ''});
    this.setState({dataAlteracaoInicial: ''});
    this.setState({dataAlteracaoFinal: ''});
    this.setState({grupoTrabalho: null});
    this.setState({tipo: null});
    this.setState({tipoAtividade: null});
    this.setState({ordenacao: null});
    this.setState({classificacao: null});
    this.setState({usuario: null});
    this.setState({exibirTelaConsulta: 'none'});
  }

  accepExcluirRelatorio() {
    this.excluirRelatorio();
  }

  confirmaExclusaoRelatorio(relatorio) {
      this.setState({codigoExcluirRelatorio: relatorio.codigo});
      confirmDialog({
          message: 'Deseja realmente excluir este relatório ?',
          header: 'Exclusão de Relatório',
          icon: 'pi pi-info-circle',
          acceptClassName: 'p-button-danger',
          acceptLabel: 'Sim',
          rejectLabel: 'Não',
          accept: this.accepExcluirRelatorio,
          reject: this.reject
      });
  }

  excluirRelatorio = async () => {
    this.setState({openSpinner: true});
    await this.relatorioAtividadeService.excluirRelatorio(this.state.codigoExcluirRelatorio)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Relatório de Atividade', detail:'Relatório excluído com sucesso', life: 4000});
        this.consultarRelatorioGerado();
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Atividade', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    await this.listarGruposTrabalho();
    await this.listarStatusAtividade();
    await this.listarStatusAtividadeAlterarAtividade();
    await this.listarUsuarios();
    await this.consultarRelatorioGerado();
    await this.limparConsulta();
    this.setState({openSpinner: false});
  }

  pad2 = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

  renderFooterAlteraMassa(name) {
    return (
        <div>
            <Button label="Executar Alteração" 
                    className="p-button-primary p-button-text"
                    onClick={this.alterarEmMassa}/>
            &nbsp;
            <Button label="Fechar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  alterarEmMassa = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    var dataAlteracaoFormatMassa = null;
    if(this.state.dataAlterarMassa != '' && this.state.dataAlterarMassa != null){
        var dateInicial = this.state.dataAlterarMassa;
        var monthInicial = this.pad2(dateInicial.getMonth()+1);//months (0-11)
        var dayInicial = this.pad2(dateInicial.getDate());//day (1-31)
        var yearInicial= dateInicial.getFullYear();
        dataAlteracaoFormatMassa = yearInicial+"-"+monthInicial+"-"+dayInicial;
    } else {
      dataAlteracaoFormatMassa = null;
    }

    var atividades = [];
    for(let i = 0; i < this.state.selectAtividades.length; i++) {
      const atividade = {
        codigo: this.state.selectAtividades[i].codigo
      };
      atividades.push(atividade);
    }

    const atividadeAlterar = {
      atividades: atividades,
      usuario: usuarioLogado,
      dataLimite: dataAlteracaoFormatMassa,
      status: this.state.statusAlterarMassa,
      historico: this.state.historicoAlterarMassa,
    }

    this.AtividadeService.alterarMassa(atividadeAlterar)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Relatório de Atividade', detail:'Operação realizada com sucesso', life: 4000});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Relatório de Atividade', detail:`${error}`, life: 4000});
      })
  }

  telaAlterarMassa(name, position){
    const usuarioLogado = this.context.usuarioAutenticado;
    if(usuarioLogado.perfil.codigo != 1) {
      this.toast.show({severity:'warn', summary: 'Relatório de Atividade', detail:'Você não tem permissão para realizar esta ação', life: 4000});
      return;
    }

    if(this.state.selectAtividades == null || this.state.selectAtividades.length == 0) {
      this.toast.show({severity:'warn', summary: 'Relatório de Atividade', detail:'Nenhuma atividade foi selecionada', life: 4000});
      return;
    }
    let state = {
      [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState({dataAlterarMassa: null});
    this.setState({statusAlterarMassa: null});
    this.setState({historicoAlterarMassa: ''});
    this.setState(state);
  }

  render() {
    const { upLoadFiles } = this.state;
    const usuarioLogado = this.context.usuarioAutenticado;
    const usuarioPerfil = usuarioLogado.perfil.codigo;
    var alterarMassa = 'none';
    if(usuarioPerfil == 1) {
      alterarMassa = 'block';
    }
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
            <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="pi pi-file-pdf"></i>
                        <span> Relatório de Ativdades</span>
                      </h3>  
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Data Limite Inicial</label>
                            <Calendar id="mask" 
                                      value={this.state.dataLimiteInicial} 
                                      onChange={(e) => this.setState({ dataLimiteInicial: e.value })} 
                                      style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                          <label>Data Limite Final</label>
                            <Calendar id="mask" 
                                        value={this.state.dataLimiteFinal} 
                                        onChange={(e) => this.setState({ dataLimiteFinal: e.value })} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        dateFormat="dd/mm/yy"
                                        mask="99/99/9999"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Prazo Fatal Inicial</label>
                            <Calendar id="mask" 
                                      value={this.state.dataFatalInicial} 
                                      onChange={(e) => this.setState({ dataFatalInicial: e.value })} 
                                      style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                          <label>Prazo Fatal Final</label>
                            <Calendar id="mask" 
                                        value={this.state.dataFatalFinal} 
                                        onChange={(e) => this.setState({ dataFatalFinal: e.value })} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        dateFormat="dd/mm/yy"
                                        mask="99/99/9999"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Data de Conclusão Inicial</label>
                            <Calendar id="mask" 
                                      value={this.state.dataConcluidoInicial} 
                                      onChange={(e) => this.setState({ dataConcluidoInicial: e.value })} 
                                      style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                          <label>Data de Conclusão Final</label>
                            <Calendar id="mask" 
                                        value={this.state.dataConcluidoFinal} 
                                        onChange={(e) => this.setState({ dataConcluidoFinal: e.value })} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        dateFormat="dd/mm/yy"
                                        mask="99/99/9999"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Data de Alteração Inicial</label>
                            <Calendar id="mask" 
                                      value={this.state.dataAlteracaoInicial} 
                                      onChange={(e) => this.setState({ dataAlteracaoInicial: e.value })} 
                                      style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                          <label>Data de Alteração Final</label>
                            <Calendar id="mask" 
                                        value={this.state.dataAlteracaoFinal} 
                                        onChange={(e) => this.setState({ dataAlteracaoFinal: e.value })} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        dateFormat="dd/mm/yy"
                                        mask="99/99/9999"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Data de Cadastro Inicial</label>
                            <Calendar id="mask" 
                                      value={this.state.dataCadastroInicial} 
                                      onChange={(e) => this.setState({ dataCadastroInicial: e.value })} 
                                      style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Data de Cadastro Final</label>
                            <Calendar id="mask" 
                                        value={this.state.dataCadastroFinal} 
                                        onChange={(e) => this.setState({ dataCadastroFinal: e.value })} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        dateFormat="dd/mm/yy"
                                        mask="99/99/9999"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Usuário</label>
                            <Dropdown   inputId="usuarios" 
                                        value={this.state.usuario} 
                                        options={this.state.usuarios} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        onChange={(e) => this.setState({ usuario: e.value })} 
                                        filter showClear filterBy="nome"
                                        optionLabel="nome" />
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Tipo Usuário</label>
                            <Dropdown   inputId="tipoUsuario" 
                                        value={this.state.tipo} 
                                        options={this.tiposUsuario} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        onChange={(e) => this.setState({ tipo: e.value })} 
                                        filter showClear filterBy="nome"
                                        optionLabel="nome" />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Grupo de Trabalho</label>
                            <Dropdown   inputId="gruposTrabalho" 
                                        value={this.state.grupoTrabalho} 
                                        options={this.state.gruposTrabalho} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        onChange={(e) => this.setState({ grupoTrabalho: e.value })} 
                                        filter showClear filterBy="nome"
                                        optionLabel="nome" />
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Status</label>
                            <MultiSelect inputId="status" 
                                         value={this.state.status} 
                                         options={this.state.statusLista} 
                                         style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                         onChange={(e) => this.setState({ status: e.value })} 
                                         filter showClear filterBy="status"
                                         optionLabel="status" />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-8">
                          <div className="form-group">
                            <label>Tipo de Atividade</label>
                            <Dropdown inputId="tipoAtividade" 
                                      value={this.state.tipoAtividade} 
                                      options={this.tiposAtividade} 
                                      style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                      onChange={(e) => this.setState({ tipoAtividade: e.value })} 
                                      filter showClear filterBy="nome"
                                      optionLabel="nome" />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Classificação</label>
                            <Dropdown   inputId="classificacao" 
                                        value={this.state.classificacao} 
                                        options={this.classificacoes} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        onChange={(e) => this.setState({ classificacao: e.value })} 
                                        filter showClear filterBy="nome"
                                        optionLabel="nome" />
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Ordenação</label>
                            <Dropdown   inputId="ordem" 
                                        value={this.state.ordenacao} 
                                        options={this.ordenacoes} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        onChange={(e) => this.setState({ ordenacao: e.value })} 
                                        filter showClear filterBy="nome"
                                        optionLabel="nome" />
                          </div>
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-sm-8">
                          <div className="form-group">
                              <Button label="Consulta em Tela"
                                      className="p-button-primary p-button-text"
                                      onClick={this.consultarAtividades}/>
                              &nbsp;
                              <Button label="Exportar Relatório"
                                        className="p-button-primary p-button-text"
                                        onClick={this.exportarRelatorio}/>
                              &nbsp;
                              <Button label="Alteração em massa"
                                      className="p-button-warning p-button-text"
                                      onClick={() => this.telaAlterarMassa('alteraMassa')}/>
                              &nbsp;
                              <Button label="Limpar Campos" 
                                      className="p-button-secondary p-button-text"
                                      onClick={this.limparConsulta}/>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={{display: `${this.state.exibirTelaConsulta}`}}>
                      <div className="row" style={{padding: '10px'}}>
                        <div className="col-sm-12">
                          <div className="form-group">
                            <strong><h4>Quantidade de Atividades: &nbsp;{this.state.totalAtividades}</h4></strong>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <DataTable value={this.state.atividades}  paginator responsiveLayout="scroll"
                            selection={this.state.selectAtividades} onSelectionChange={(e) => this.setState({ selectAtividades: e.value })}
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10} emptyMessage=" "
                            selectionMode="multiple">
                              <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} exportable={false}></Column>
                              <Column body={this.acoesAtividade} exportable={false} style={{ minWidth: '8rem' }}header="Atividade"></Column>
                              <Column field="tipoAtividade" header="Tipo"></Column>
                              <Column field="descricao" header="Descrição"></Column>
                              <Column field="dataLimite" header="Dt. Limite"></Column>
                              <Column field="dataFatal" header="Prazo Fatal"></Column>
                              <Column field="responsavel" header="Responsável"></Column>
                              <Column field="subGrupo" header="Sub-Grupo"></Column>
                              <Column field="grupo" header="Grupo de Trabalho"></Column>
                              <Column field="status" header="Status"></Column>
                              <Column field="dataConcluido" header="Dt. Conclusão"></Column>
                              <Column field="numerocnj" header="CNJ"></Column>
                              <Column field="numeroProcesso" header="N. Processo"></Column>
                              <Column field="numeroPasta" header="Pasta"></Column>
                              <Column field="autor" header="Autor"></Column>
                              <Column field="reu" header="Réu"></Column>
                          </DataTable>
                        </div>
                      </div>
                    </div>
                    <hr></hr>
                    <br></br>
                    <div className="row">
                      <div className="col-sm-12">
                      <Accordion>
                          <AccordionTab header="Relatórios Gerados">
                            <DataTable value={this.state.relatorioGerado}  paginator responsiveLayout="scroll"
                              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                              currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10} emptyMessage="Nehum relatório gerado"
                              selectionMode="multiple">
                              <Column field="relatorio" header="Relatório"></Column>
                              <Column field="dataRelatorio" header="Data Geração"></Column>
                              <Column body={this.acoes} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                            </DataTable>
                          </AccordionTab>
                        </Accordion>
                      </div>
                    </div>
                  </div>
                  {/**Alteração em Massa */}
                  <Dialog header="Alterar atividades em massa"
                          visible={this.state.alteraMassa} 
                          style={{ width: '40vw' }} 
                          footer={this.renderFooterAlteraMassa('alteraMassa')} 
                          onHide={() => this.fecharModal('alteraMassa')}>
                    
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">  
                          <label>Nova Data Limite</label>
                          <Calendar id="mask" 
                                      value={this.state.dataAlterarMassa} 
                                      onChange={(e) => this.setState({ dataAlterarMassa: e.value })} 
                                      style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">  
                          <label>Novo Status de Atividade</label>
                          <Dropdown inputId="status" 
                                    value={this.state.statusAlterarMassa} 
                                    options={this.state.statusLista} 
                                    style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                    onChange={(e) => this.setState({ statusAlterarMassa: e.value })} 
                                    filter showClear filterBy="status"
                                    optionLabel="status" />
                        </div>
                      </div>
                    </div>
                  </Dialog>
                  {/**Alterar Atividade */}
                  <Dialog header="Atividade" autoComplete="nope"
                          visible={this.state.displayAtividade} 
                          footer={this.renderFooterAtividade('displayAtividade')} 
                          onHide={() => this.fecharModalAtividade('displayAtividade')}>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <InputText id="titulo" 
                                        style={{width: '100%', height: '32px'}}
                                        type="text" 
                                        autoComplete="nope"
                                        value={this.state.titulo}
                                        onChange={e => this.setState({titulo: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"
                                        placeholder="Título"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group" style={{display: `${this.state.campoPesquisaProcesso}`}}>
                            <InputText id="processo" style={{width: '100%', height: '32px'}}
                                      type="text"
                                      autoComplete="nope"
                                      value={this.state.pesquisaProcesso}
                                      onKeyPress={event => event.key === 'Enter' && this.consultarProcessoPorIndice()}
                                      onChange={e => this.setState({pesquisaProcesso: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      placeholder="Incluir Processo, Pesquise o processo por Pessoa, Pasta ou Número"/>
                          </div>
                          <div className="form-group" style={{display: `${this.state.processoPesquisadoVisivel}`}}>
                            <strong>Processo:&nbsp;&nbsp;
                                      <a className="cursor" 
                                        href={this.state.paramProcessoPrincipal}
                                        target="_blank"
                                        onClick={this.editarProcessoNaAtividade}>{this.state.processoPesquisado}</a>
                            <br/>
                            {this.state.partes}
                            <div style={{textAlign: 'left'}}>
                              <Button icon="pi pi-heart"
                                      className={this.state.favorito} 
                                      tooltip={this.state.titleFavorito} 
                                      tooltipOptions={{ className: 'blue-tooltip', position: 'top' }} 
                                      style={{width: '20px', height: '10px', display: `${this.state.exibirFavorito}`}}/>
                              &nbsp;
                              <Button icon="pi pi-star" 
                                      className={this.state.importante}
                                      tooltip={this.state.titileImportante} 
                                      tooltipOptions={{ className: 'blue-tooltip', position: 'top' }} 
                                      style={{width: '20px', height: '10px', display: `${this.state.exibirImportanteEmpresa}`}} />
                            </div>
                            </strong>
                            <br />
                            <a onClick={this.excluirPesquisaProcesso} className="linkCadGrupo" style={{cursor: 'pointer'}}>Desvincular Processo</a>
                          </div>
                        </div>
                      </div>
                      
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Dropdown value={this.state.selectGrupo} style={{width: '100%', height: '32px'}} 
                              options={this.state.grupos}
                              disabled={this.state.bloqueiaGrupo}
                              optionLabel="nome" 
                              filter showClear filterBy="nome"
                              onChange={this.onGrupoTrabalhoChange}
                              id="grupoTrabalho"
                              className="p-inputtext-sm p-d-block p-mb-1"
                              placeholder="Grupo de Trabalho"/>
                              <a className="linkCadGrupo" href="#">Incluir novo Grupo de Trabalho</a>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Dropdown value={this.state.selectSubGrupo} style={{width: '100%', height: '32px'}} 
                            options={this.state.subGrupos} style={{width: '100%', height: '32px'}}
                            optionLabel="nome" 
                            emptyMessage=" "
                            filter showClear filterBy="nome"
                            onChange={this.onSubGrupoChange}
                            id="subGrupoTrabalho"
                            className="p-inputtext-sm p-d-block p-mb-1"
                            placeholder="Sub-Grupo de Trabalho"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <MultiSelect inputId="multiselect" 
                                          value={this.state.responsaveisLista} 
                                          options={this.state.responsaveis} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ responsaveisLista: e.value })} 
                                          filter showClear filterBy="nome"
                                          optionLabel="nome" 
                                          placeholder="Responsáveis"/>
                            <label className="linkCadGrupo">{this.state.quantidadeResponsaveis}</label>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <MultiSelect inputId="multiselect" 
                                          value={this.state.interessadosLista} 
                                          options={this.state.responsaveis} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ interessadosLista: e.value })}  
                                          filter showClear filterBy="nome"
                                          optionLabel="nome" 
                                          placeholder="Interssados"/>
                            <label className="linkCadGrupo">{this.state.quantidadeInteressados}</label>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-3">
                          <div className="form-group">
                            <Calendar id="mask" 
                                      value={this.state.dtLimite} 
                                      onChange={(e) => this.setState({ dtLimite: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"
                                      placeholder="Data Limite"/>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div className="form-group">
                          <InputMask id="hora" style={{width: '100%', height: '32px'}}
                                      type="text"
                                      mask="99:99"
                                      value={this.state.hora}
                                      onChange={e => this.setState({hora: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Calendar id="mask" 
                                      value={this.state.dtFatal} 
                                      onChange={(e) => this.setState({ dtFatal: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"
                                      placeholder="Prazo fatal"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <InputTextarea value={this.state.descricao} style={{width: '100%'}}
                                            id="descricaoE"
                                            onChange={e => this.setState({descricao: e.target.value})}
                                            rows={4} 
                                            cols={60} />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <Dropdown value={this.state.statusAtividadeAlterar} style={{width: '100%', height: '32px'}} 
                                      options={this.state.statusAtividade} style={{width: '100%', height: '32px'}}
                                      optionLabel="status" 
                                      emptyMessage=" "
                                      filter showClear filterBy="status"
                                      onChange={this.onChangeStatusAtividade}
                                      id="idStatusAtividade"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                  </Dialog>
                  {/**Arquivos Anexados */}
                  <Dialog header="Arquivos Anexados"
                          style={{ width: '40vw' }} 
                          visible={this.state.displayArquivosAnexados} 
                          footer={
                            <frameElement>
                              <Button label="Fechar" 
                                      className="p-button-secondary p-button-text"
                                      onClick={() => this.fecharModalAtividade('displayArquivosAnexados')}/>
                            </frameElement>
                            
                          } 
                          onHide={() => this.fecharModalAtividade('displayArquivosAnexados')}>
                      
                      <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">  
                              <div className="container">
                                
                                <Upload onUpload={this.handleUpload}/>
                                {!!upLoadFiles && (
                                  <FileList files={upLoadFiles} onDelete={this.handleDelete}/>
                                )}
                              
                              </div>
                            </div>
                          </div>
                        </div>
                        <DataTable value={this.state.arquivos} paginator responsiveLayout="scroll" size="small"
                                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                    currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                                    emptyMessage="Nenhum Arquivo">
                          <Column field="arquivo" header="Arquivo"/>
                          <Column field="dsArquivo" header="Descrição"/>
                          <Column body={this.acoesArquivos} exportable={false} style={{ minWidth: '8rem' }} header="Ações"/>
                        </DataTable> 
                    </Dialog>  
                    {/**Adicionar descrição ao arquivo */}
                    <Dialog header="Descrição do Arquivo"
                            visible={this.state.modalDescricaoArquivo} 
                            style={{ width: '40vw' }} 
                            footer={this.renderFooterDescricaoArquivo('modalDescricaoArquivo')}
                            onHide={() => this.fecharModal('modalDescricaoArquivo')}>

                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label htmlFor="descricaoArquivo">Descrição</label>
                              <InputText id="descricaoArquivo" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.dsArquivo}
                                    onChange={e => this.setState({dsArquivo: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                  </Dialog> 
                  {/**Histórico de Atividades */}
                  <Dialog header="Histórico da Ativide" autoComplete="nope"
                          style={{ width: '50vw' }} 
                          visible={this.state.displayHistorico} 
                          footer={
                            <frameElement>
                              <Button label="Incluir" 
                                      className="p-button-primary p-button-text"
                                      onClick={this.novoHistorico}/>
                              &nbsp;
                              <Button label="Fechar" 
                                      className="p-button-secondary p-button-text"
                                      onClick={() => this.fecharModal('displayHistorico')}/>
                            </frameElement>
                            
                          } 
                          onHide={() => this.fecharModalAtividade('displayHistorico')}>
                    <DataTable value={this.state.historico}  paginator responsiveLayout="scroll"
                              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                              currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={5} emptyMessage=" "
                              selectionMode="multiple">
                      <Column body={this.acoesHistoricoUsuario} exportable={false} style={{ minWidth: '4rem' }}></Column>
                      <Column field="dsHistorico" header="Histórico"></Column>
                      <Column field="dtHistorico" header="Data"></Column>
                      <Column field="usuario.nome" header="Usuário"></Column>
                      <Column body={this.acoesHistorico} exportable={false} style={{ minWidth: '4rem' }}></Column>
                    </DataTable>
                  </Dialog>
                  {/**Incluir um novo histórico */}
                  <Dialog header="Incluir Histórico" autoComplete="nope"
                          style={{ width: '40vw' }} 
                          visible={this.state.displayHistoricoIncluir} 
                          footer={
                            <frameElement>
                              <Button label="Incluir" 
                                      className="p-button-primary p-button-text"
                                      onClick={() => this.incluirHistorico()}/>
                              &nbsp;
                              <Button label="Fechar" 
                                      className="p-button-secondary p-button-text"
                                      onClick={() => this.fecharModalAtividade('displayHistoricoIncluir')}/>
                            </frameElement>
                            
                          } 
                          onHide={() => this.fecharModalAtividade('displayHistoricoIncluir')}> 
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <InputTextarea id="historico" 
                                          type="text" 
                                          autoComplete="nope"
                                          style={{width: '100%'}} 
                                          value={this.state.dsHistorico}
                                          onChange={e => this.setState({dsHistorico: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"
                                          rows={6} cols={30}/>
                        </div>
                      </div>
                    </div>  
                  </Dialog>
                  {/**Descrição da Atividade */}
                  <Dialog header="Descrição da Atividade"
                          style={{ width: '50vw' }} 
                          visible={this.state.displayDescricao} 
                          footer={
                            <frameElement>
                              <Button label="Salvar" 
                                      className="p-button-secondary p-button-text"
                                      onClick={() => this.fecharModal('displayDescricao')}/>
                            </frameElement>
                            
                          } 
                          onHide={() => this.fecharModal('displayDescricao')}>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <InputTextarea id="idDescricao" 
                                          type="text" 
                                          autoComplete="nope"
                                          style={{width: '100%'}} 
                                          value={this.state.descricao}
                                          onChange={e => this.setState({descricao: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"
                                          rows={6} cols={30}/>
                        </div>
                      </div>
                    </div>
                  </Dialog>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    )
  }
}

RelatorioAtividades.contextType = AuthContext;
export default withRouter(RelatorioAtividades)